import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';
import { IOtherName, IRisk } from '../../../../types';
import { SummaryList } from '../../../Summary/SummaryList';
import { SummaryListItem } from '../../../Summary/SummaryListItem';
import { useTranslation } from "react-i18next";

interface Props {
  showRisks: boolean;
  surname?: string;
  middleName?: string;
  givenName?: string;
  hasOtherNames: string;
  otherNames?: Array<IOtherName>;
  riskList: IRisk['personalInfoRisk']['namesAndAliases'];
}

function NameAndDOB({ showRisks, surname, middleName, givenName, hasOtherNames, otherNames, riskList }: Props) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      {givenName && (
        <SummaryRow
          key="giveName"
          label={t('forms.visa:givenName')}
          value={givenName}
          isRisk={showRisks && riskList.includes(Q.GIVEN_NAME)}
        />
      )}
      {middleName && (
        <SummaryRow
          key="middleName"
          label={t('forms.visa:middleName')}
          value={middleName}
          isRisk={showRisks && riskList.includes(Q.MIDDLE_NAME)}
        />
      )}
      {surname && (
        <SummaryRow
          key="surname"
          label={t('forms.visa:familyName')}
          value={surname}
          isRisk={showRisks && riskList.includes(Q.SURNAME)}
        />
      )}
      {hasOtherNames && (
        <SummaryRow
          key="hasOtherNames"
          label={t('forms.visa:hasOtherNames2')}
          fullLabel="In addition to the names already provided, are you now or have you ever been known by another name?"
          value={hasOtherNames}
          isRisk={showRisks && riskList.includes(Q.HAS_OTHER_NAMES)}
        />
      )}
      {hasOtherNames && otherNames !== undefined && (
        <SummaryRow className={'summary'} value={otherNames?.length} label={t('forms.visa:howMany')} fullLabel={'How many names?'} />
      )}
      {hasOtherNames === 'Yes' && otherNames !== undefined && (
        <>
          <SummaryList
            title={t('forms.visa:alternativeOrPreviousNames')}
            tooltip={t('forms.visa:otherGivenNameSOtherFamilyNameRe')}
          >
            {otherNames.map((name, index) => {
              return (
                <SummaryListItem
                  key={`other-name-${index}`}
                  value={`${name.givenName} - ${name.surname}`}
                  subvalue={`Reason: ${name.reason}`}
                />
              );
            })}
          </SummaryList>
        </>
      )}
    </>
  );
}

export default NameAndDOB;
